/**
 * Returns the browser "instance" mixpanel enrichment to be sent over each event.
 * @return {Object}
 */
const getInstanceEnrichment = () => (
    window.mixpanelEnrichment || {}
);

export default getInstanceEnrichment;
